import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mobile-track" }
const _hoisted_2 = { class: "row-container" }
const _hoisted_3 = { class: "point" }
const _hoisted_4 = { class: "img" }
const _hoisted_5 = { class: "tile-container" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "progress-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Tick = _resolveComponent("Tick")!
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_Tile = _resolveComponent("Tile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hotspotTitles, (title, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "hotspot",
          key: title
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.edit)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    icon: ['far', 'circle'],
                    class: _normalizeClass(["mobile-hotspot-icon edit", { active: index === _ctx.activePoint }]),
                    size: "3x",
                    onClick: ($event: any) => (_ctx.setActivePoint(index))
                  }, null, 8, ["class", "onClick"]))
                : (_openBlock(), _createBlock(_component_Tick, {
                    key: 1,
                    class: "mobile-hotspot-icon",
                    size: "3x",
                    active: 
                _ctx.hotspots[index].hotspotProgressObjects.length
                  ? _ctx.hotspots[index].hotspotProgressObjects[0]
                      .progressPercentage === 100
                  : false
              ,
                    round: ""
                  }, null, 8, ["active"]))
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["line", {
              first: index === 0,
              last: index === _ctx.hotspotTitles.length - 1,
            }])
            }, null, 2)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Tile, {
              onClick: ($event: any) => (_ctx.handleTileClick(index))
            }, {
              text: _withCtx(() => [
                _createVNode(_component_TranslatedText, { path: title }, null, 8, ["path"]),
                (!_ctx.edit)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("span", _hoisted_7, [
                        _createTextVNode(" (" + _toDisplayString(_ctx.hotspots[index].hotspotProgressObjects.length
                      ? _ctx.hotspots[index].hotspotProgressObjects[0]
                          .progressPercentage
                      : 0) + "% ", 1),
                        _createVNode(_component_TranslatedText, { path: "progress.complete" }),
                        _cache[0] || (_cache[0] = _createTextVNode(") ", -1))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]))
      }), 128))
    ])
  ]))
}